module.exports = __webpack_public_path__ + "static/media/Sujet.7d018081.jpg";